export default {
  // API_ENDPOINT: 'http://localhost:8080/api',
  API_ENDPOINT: 'https://calm-basin-50709.herokuapp.com/api'
};